var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferOutPatiend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 7,
    fill: "#E3E9F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2083 64.0001C43.5146 64.0001 42.8625 63.6543 42.475 63.073L38.9271 57.7501H34.8333C33.6833 57.7501 32.75 56.8168 32.75 55.6668C32.75 54.5168 33.6833 53.5834 34.8333 53.5834H40.0417C40.7375 53.5834 41.3875 53.9313 41.775 54.5105L43.95 57.773L48.5937 48.4834C48.9354 47.8043 49.6167 47.3626 50.3771 47.3334C51.1854 47.3147 51.8521 47.6918 52.2437 48.3418L57.8875 57.7501H61.9167C63.0667 57.7501 64 58.6834 64 59.8334C64 60.9834 63.0667 61.9168 61.9167 61.9168H56.7083C55.9771 61.9168 55.2979 61.5334 54.9229 60.9063L50.625 53.7438L46.0729 62.8501C45.7396 63.5147 45.0792 63.9522 44.3375 63.998C44.2958 64.0001 44.2521 64.0001 44.2083 64.0001Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 34.8333C38.503 34.8333 43.1667 30.1696 43.1667 24.4167C43.1667 18.6637 38.503 14 32.75 14C26.9971 14 22.3334 18.6637 22.3334 24.4167C22.3334 30.1696 26.9971 34.8333 32.75 34.8333Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 55.6667C28.5833 52.2208 31.3875 49.4167 34.8333 49.4167H40.0417C41.1229 49.4167 42.1646 49.6938 43.0792 50.2021L44.8687 46.6208C45.7792 44.8062 47.5125 43.6167 49.4813 43.3C47.5854 40.7063 44.5437 39 41.0833 39H24.4167C18.6646 39 14 43.6646 14 49.4167V56.1875C14 57.05 14.7 57.75 15.5625 57.75H28.9667C28.7333 57.0958 28.5833 56.4 28.5833 55.6667Z",
    fill: "#17468C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferOutPatiend);
export default __webpack_public_path__ + "static/media/refer-out-patiend.058d25cd4b09a6584767d0cadc4606d3.svg";
export { ForwardRef as ReactComponent };